function redirectToCountry(){
  //delete geo targetly cookie that suppresses the banner/popup
  document.cookie = 'geotargetly_redirectpopup_1594059428845_close_cookie=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
  document.cookie = 'geotargetly_redirectpopup_1594059428845_redirect_cookie=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
  
  //get selected country and do redirect
  let picker = document.getElementById("RedirectCountryPicker");
  let selectedOption = picker.options[picker.selectedIndex];
  let countryIso = selectedOption.getAttribute('country-iso');
//   addParam('deleteGeoCookies','true');
//   addParam('co-iso', countryIso);
  //create a cookie with the country code of the country the user selected
  var date = new Date();
  date.setTime(date.getTime()+(30*24*3600*1000));
  document.cookie = 'countryRedirect=' + countryIso + '; expires='+date.toUTCString() + '; path=/; domain=.savannahs.com';
  let url = selectedOption.value + window.location.pathname + window.location.search;
  window.location.href = url;
}

// function addParam(key, value) {
//   key = encodeURIComponent(key);
//   value = encodeURIComponent(value);

//   var kvp = document.location.search.substr(1).split('&');
//   let i = 0;
//   if(kvp[0].length === 0) {
//     kvp.shift();
//   }

//   for(; i < kvp.length; i++){
//     if (kvp[i].startsWith(key + '=')) {
//       let pair = kvp[i].split('=');
//       pair[1] = value;
//       kvp[i] = pair.join('=');
//       break;
//     }
//   }

//   if(i >= kvp.length){
//     kvp[kvp.length] = [key,value].join('=');
//   }

//   let params = '?' + kvp.join('&');
//   window.history.replaceState(null, null, params);
// }